import React from 'react';
import ActionsButtonsBaseModal from 'components/atoms/ActionsButtonsBaseModal';
import { Button, Typography, Grid } from '@material-ui/core';
import ButtonWithLoading from 'components/atoms/ButtonWithLoading';
import { IModalDeleteProps } from './types';
import useStyles from './style';

const GridModalDelete = ({
  open,
  onClose,
  children,
  selectedRows,
  reloadData,
  service,
  idPlan,
  idReal,
  idKey,
  idDiverse,
}: IModalDeleteProps) => {
  const classes = useStyles();
  const [loadingSaveForm, setLoadingSaveForm] = React.useState<boolean>(false);

  const idsPlan = React.useMemo(() => {
    return selectedRows.map(row => {
      if (idPlan in (row || {})) return row[idPlan];
      return null;
    });
  }, [idPlan, selectedRows]);

  const idsReal = React.useMemo(() => {
    return selectedRows.map(row => {
      if (idReal in (row || {})) return row[idReal];
      return null;
    });
  }, [idReal, selectedRows]);

  const ids = React.useMemo(() => {
    return selectedRows.map(row => {
      if (idKey in (row || {})) return row[idKey];

      return null;
    });
  }, [idKey, selectedRows]);

  const idsDiverse = React.useMemo(() => {
    return selectedRows.map(row => {
      if (idDiverse in (row || {})) return row[idDiverse];

      return null;
    });
  }, [idDiverse, selectedRows]);

  const handleCallService = React.useCallback(() => {
    setLoadingSaveForm(true);
    const params = { idsPlan, idsReal, ids, idsDiverse };
    service(params)
      .then(() => {
        if (reloadData) reloadData();
        onClose();
      })
      .finally(() => setLoadingSaveForm(false));
  }, [idsPlan, idsReal, ids, idsDiverse, onClose, reloadData, service]);

  const renderbody = React.useCallback(() => {
    return (
      <>
        <Grid className={classes.modalBody}>
          <Typography className={classes.formMessage}>
            Os itens selecionados serão excluídos.
          </Typography>
          <Typography className={classes.formMessage}>
            Deseja confirmar?
          </Typography>
        </Grid>
      </>
    );
  }, [classes.formMessage, classes.modalBody]);

  const renderFooter = React.useCallback(() => {
    return (
      <div>
        <Button color="primary" onClick={onClose}>
          Cancelar
        </Button>
        <ButtonWithLoading
          isLoading={loadingSaveForm}
          onClick={handleCallService}
          color="primary"
        >
          Confirmar
        </ButtonWithLoading>
      </div>
    );
  }, [handleCallService, loadingSaveForm, onClose]);

  return (
    <>
      <ActionsButtonsBaseModal
        title="Confirmar Exclusão"
        open={open}
        onClose={onClose}
        body={renderbody()}
        footer={renderFooter()}
        width="433px"
        disableBackDropClickByReasons={['backdropClick', 'escapeKeyDown']}
      >
        {children}
      </ActionsButtonsBaseModal>
    </>
  );
};

export default GridModalDelete;
